import { render } from "./WwtpCreate.vue?vue&type=template&id=213334a8"
import script from "./WwtpCreate.vue?vue&type=script&lang=js"
export * from "./WwtpCreate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__